import { useState } from 'react'

export const useInputChange = (defaultValue) => {
  const [input, setInput] = useState(defaultValue)

  const handleInputChange = (e) => setInput(e.currentTarget.value ? e.currentTarget.value.trim(): e.currentTarget.value)

  const setDefaults = () => {
     setInput(defaultValue);
  }

  const clearValues = () => {
    setInput(undefined);
  }

  return [input, handleInputChange, clearValues, setDefaults]
}